import React from "react";

export type SummaryCardProps = {
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
};

export default function SummaryCard({
  className = "",
  bodyClassName = "",
  children,
}: SummaryCardProps): JSX.Element {
  return (
    <div className={`card shadow border-0 rounded-4 h-100 ${className}`}>
      <div className={`card-body ${bodyClassName}`}>{children}</div>
    </div>
  );
}